/* cz-megamenu-hover.js - ouverture au survol + fermeture quand la souris quitte le menu (desktop pointeur uniquement). Non destructif : utilise l'API publique open()/close()/isOpen de dropdown-component (assets/dropdown.js). Cible les items de nav du header (Garmin megamenu + Accessoires), exclut les selecteurs devise/langue. */
(function () {
  var mq = window.matchMedia('(hover: hover) and (pointer: fine)');
  var CLOSE_DELAY = 140; // grace period : traverser un petit espace ne ferme pas
  var OPEN_DELAY = 60;   // petit delai a l'ouverture pour eviter les ouvertures accidentelles en passant vite

  function enhance(dd) {
    if (dd.__czHover) return;
    dd.__czHover = true;
    var closeTimer = null, openTimer = null;
    function cancelClose() { if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; } }
    function cancelOpen() { if (openTimer) { clearTimeout(openTimer); openTimer = null; } }

    dd.addEventListener('mouseenter', function () {
      if (!mq.matches) return;
      cancelClose();
      if (!dd.isOpen) {
        openTimer = setTimeout(function () {
          var group = dd.closest('dropdown-group-component');
          if (group && group.closeAllDropdowns) group.closeAllDropdowns();
          if (dd.open) dd.open();
        }, OPEN_DELAY);
      }
    });

    dd.addEventListener('mouseleave', function () {
      if (!mq.matches) return;
      cancelOpen();
      cancelClose();
      closeTimer = setTimeout(function () { if (dd.close) dd.close(); }, CLOSE_DELAY);
    });
  }

  function initAll() {
    var sel = 'header dropdown-component.header__menu-item, .header dropdown-component.header__menu-item';
    document.querySelectorAll(sel).forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
